import { gql } from '@apollo/client'

const SUBSCRIPTION_RESUME_MUTATION = gql`
  mutation SubscriptionResumeMutation(
    $numOfBoxes: Int!
    $deliveryDate: ISO8601Date
  ) {
    subscriptionResumeWithDeliveryDate(deliveryDate: $deliveryDate) {
      id
      subscription {
        id
        status
        increasedDeliveryCadencePlan {
          id
        }
        nextNBoxes(num: $numOfBoxes) {
          id
          cutOffDate
          isTrialBox
          isoDeliveryDate
          editable
          descriptor
        }
      }
    }
  }
`

export { SUBSCRIPTION_RESUME_MUTATION }
